import ApiLogsExplorer from './ApiLogsExplorer';

interface DashboardLogsViewProps {
  userId: string;
}

export default function DashboardLogsView({}: DashboardLogsViewProps) {
  return (
    <div>
      <div className="mb-6">
        <h2 className="text-2xl font-bold text-gray-900 mb-2">API Logs</h2>
        <p className="text-gray-600">View and analyze your API request logs</p>
      </div>

      {/* API Logs Explorer */}
      <ApiLogsExplorer />

      {/* Info banner */}
      <div className="mt-6 bg-blue-50 border border-blue-200 rounded-2xl p-6">
        <div className="flex items-start gap-4">
          <div className="w-10 h-10 bg-blue-500 rounded-full flex items-center justify-center flex-shrink-0">
            <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
          </div>
          <div>
            <h3 className="font-semibold text-gray-900 mb-2">About API Logs</h3>
            <p className="text-sm text-gray-700 leading-relaxed">
              API logs are retained for 30 days. You can filter by endpoint, status, and search by IP address.
              Use the Export button to download logs as CSV for further analysis or compliance purposes.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
